import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: '',
    email: '',
    error: null,
    errorLogin: null,
    requesting: false,
    resultReset: null,
    isSuccess: false,
  },
  reducers: {
    authLoginRequest: (state) => {
      state.requesting = true;
    },
    authLoginSuccess: (state, { payload }) => {
      state.token = payload.token;
      state.email = payload.email;
      state.errorLogin = null;
      state.requesting = false;
    },
    authLoginError: (state, action) => {
      state.errorLogin = action.payload;
      state.requesting = false;
    },
    authLogoutRequest: (state) => {
      state.requesting = true;
    },
    authLogoutSuccess: (state) => {
      state.token = null;
      state.error = null;
      state.errorLogin = null;
    },
    authLogoutError: (state, action) => {
      state.error = action.payload;
      state.errorLogin = action.payload;
      state.requesting = false;
      state.isSuccess = null;
    },
    authRegisterRequest: (state) => {
      state.requesting = true;
      state.isSuccess = null;
    },
    authRegisterSuccess: (state) => {
      state.requesting = false;
      state.token = null;
      state.error = null;
      state.isSuccess = true;
    },
    authRegisterError: (state, action) => {
      state.error = action.payload;
      state.requesting = false;
    },
    authResetPasswordRequest: (state) => {
      state.requesting = true;
    },
    authResetPasswordSuccess: (state, action) => {
      state.resultReset = true;
      state.error = null;
    },
    authResetPasswordError: (state, action) => {
      state.error = action.payload;
      state.requesting = false;
    },
    authUpdateRequesting: (state, action) => {
      state.requesting = action.payload;
    },
  },
});

export const {
  authLoginRequest,
  authLoginSuccess,
  authLoginError,
  authLogoutRequest,
  authLogoutSuccess,
  authLogoutError,
  authRegisterRequest,
  authRegisterSuccess,
  authRegisterError,
  authResetPasswordRequest,
  authResetPasswordSuccess,
  authResetPasswordError,
  authUpdateRequesting,
} = authSlice.actions;

export const selectRequesting = (state) => state.auth.requesting;
export const selectError = (state) => state.auth.error;
export const selectErrorLogin = (state) => state.auth.errorLogin;
export const selectToken = (state) => state.auth.token;
// export const selectEmail = (state) => state.auth.email;
export const selectResultReset = (state) => state.auth.resultReset;
export const selectSuccessSignup = (state) => state.auth.isSuccess;

export default authSlice.reducer;
